import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _geometryShape;

export var ShapeType3D;

(function (ShapeType3D) {
  ShapeType3D["CYLINDER"] = "cylinder";
  ShapeType3D["SQUARECOLUMN"] = "squareColumn";
  ShapeType3D["TRIANGLECOLUMN"] = "triangleColumn";
  ShapeType3D["HEXAGONCOLUMN"] = "hexagonColumn";
  ShapeType3D["PENTAGONCOLUMN"] = "pentagonColumn";
})(ShapeType3D || (ShapeType3D = {}));

export var ShapeType2D;
/**
 * 生成规则多边形顶点个数
 * @param pointCount  顶点个数 3 => 三角形
 * @param start 顶点起始角度 调整图形的方向
 */

(function (ShapeType2D) {
  ShapeType2D["CIRCLE"] = "circle";
  ShapeType2D["SQUARE"] = "square";
  ShapeType2D["TRIANGLE"] = "triangle";
  ShapeType2D["HEXAGON"] = "hexagon";
  ShapeType2D["PENTAGON"] = "pentagon";
})(ShapeType2D || (ShapeType2D = {}));

export function polygonPath(pointCount) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var step = Math.PI * 2 / pointCount;
  var line = [];

  for (var i = 0; i < pointCount; i++) {
    line.push(step * i + start * Math.PI / 12);
  }

  var path = line.map(function (t) {
    var x = Math.sin(t + Math.PI / 4);
    var y = Math.cos(t + Math.PI / 4);
    return [x, y, 0];
  }); // path.push(path[0]);

  return path;
}
export function circle() {
  return polygonPath(30);
}
export function square() {
  return polygonPath(4);
}
export function triangle() {
  return polygonPath(3);
}
export function hexagon() {
  return polygonPath(6, 1);
}
export function pentagon() {
  return polygonPath(5);
}
export var geometryShape = (_geometryShape = {}, _defineProperty(_geometryShape, ShapeType2D.CIRCLE, circle), _defineProperty(_geometryShape, ShapeType2D.HEXAGON, hexagon), _defineProperty(_geometryShape, ShapeType2D.TRIANGLE, triangle), _defineProperty(_geometryShape, ShapeType2D.SQUARE, square), _defineProperty(_geometryShape, ShapeType2D.PENTAGON, pentagon), _defineProperty(_geometryShape, ShapeType3D.CYLINDER, circle), _defineProperty(_geometryShape, ShapeType3D.HEXAGONCOLUMN, hexagon), _defineProperty(_geometryShape, ShapeType3D.TRIANGLECOLUMN, triangle), _defineProperty(_geometryShape, ShapeType3D.SQUARECOLUMN, square), _defineProperty(_geometryShape, ShapeType3D.PENTAGONCOLUMN, pentagon), _geometryShape);